(function () {
	'use strict';

	angular.module('app.core')
		.directive('resizeTables', resizeTables);

	resizeTables.$inject = ['$window', '$timeout'];
	function resizeTables($window, $timeout) {
		return {
			link: function (scope, element, attr) {
				var w = angular.element($window);
				jQuery('.row.overflow').css('maxWidth', (jQuery(window).width() - 40) + 'px');
				w.bind('resize', function () {
					jQuery('.row.overflow').css('maxWidth', (jQuery(window).width() - 40) + 'px');
					scope.$apply();
				});
			}
		};
	}
})();
